import { produce } from 'immer';
import { TemplateEditorAction, TemplateState } from '../templateeditor-types';
import { AiTemplateBuilderAction, TEMPLATE_EDITOR_AI_APPLY_CHECKBOX_GROUPING, TEMPLATE_EDITOR_AI_APPLY_FIELD_SUGGESTION } from './actions';
import { applyCheckboxFieldGrouping, applyFieldSuggestions } from './updaters';
import { setIsDirty } from '../updaters';
import { AiTemplateBuilderPayload } from './templateeditor-ai-types';

export function aiTemplateBuilderReducer(state: TemplateState, action: AiTemplateBuilderAction | TemplateEditorAction): TemplateState {
  return produce(state, (draft) => {
    switch (action.type) {
      case TEMPLATE_EDITOR_AI_APPLY_FIELD_SUGGESTION:
        return setIsDirty(applyFieldSuggestions(draft, action.payload as AiTemplateBuilderPayload));

      case TEMPLATE_EDITOR_AI_APPLY_CHECKBOX_GROUPING:
        return setIsDirty(applyCheckboxFieldGrouping(draft));

      default:
        return draft;
    }
  });
}
